
import './App.css';
import React, { useState } from 'react';
import Chat from "./Compoanents/Chat";
import Login from './Compoanents/Login';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Asking from './Compoanents/Asking'
import Register from './Compoanents/Register'
import ForgotPassword from './Compoanents/ForgotPassword';
import ResetPassword from './Compoanents/ResetPassword';
import OtpVerification from './Compoanents/OtpVerification';
import SignInTypeSelection from './Compoanents/SignInTypeSelection';
import VendorLogin from './Compoanents/VendorLogin';
import VendorDashboard from './Compoanents/VendorDashboard';
import Home from './Compoanents/Home';
import GRIRApp from './Compoanents/GRIR/GRIRApp';
import NPDApp from './Compoanents/NPD/NPDApp';
import ProcureAIApp from './Compoanents/Procurement/ProcureAIApp';
import OrderFulfillment from './Compoanents/OrderFulfillment';
import O2CAgent from './Compoanents/O2CAgent';
import OCRApp from './Compoanents/OCR/OCRApp';

const PrivateRoute = ({ children }) => {
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
    return isAuthenticated ? children : <Navigate to="/" replace />;
};

// Move AppContent into its own component to use useLocation inside Router
function AppContent({ dashboardUrl, handleSetDashboardUrl, activeNavItem, setActiveNavItem, showFAQ, setShowFAQ }) {
  // const hideWidgetRoutes = ['/', '/login', '/register', '/forgot-password', '/reset-password'];
  // const shouldHideWidget = hideWidgetRoutes.includes(location.pathname);

  return (
    <>
      <Routes>
        <Route path="/" element={<Asking />} />
        <Route path="/signin-type" element={<SignInTypeSelection />} />
        <Route path="/login" element={<Login />} />
        <Route path="/vendor-login" element={<VendorLogin />} />
        <Route path="/vendor-dashboard" element={<VendorDashboard />} />
        <Route path="/home" element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        } />
        <Route path="/grir" element={
          <PrivateRoute>
            <GRIRApp />
          </PrivateRoute>
        } />
        <Route path="/npd" element={
          <PrivateRoute>
            <NPDApp />
          </PrivateRoute>
        } />
        <Route path="/procure-ai" element={
          <PrivateRoute>
            <ProcureAIApp />
          </PrivateRoute>
        } />
        <Route path="/order-fulfillment" element={
          <PrivateRoute>
            <OrderFulfillment />
          </PrivateRoute>
        } />
        <Route path="/o2c-agent" element={
          <PrivateRoute>
            <Navigate to="/o2c-agent/upload" replace />
          </PrivateRoute>
        } />
        <Route path="/o2c-agent/upload" element={
          <PrivateRoute>
            <O2CAgent />
          </PrivateRoute>
        } />
        <Route path="/o2c-agent/dashboard" element={
          <PrivateRoute>
            <O2CAgent />
          </PrivateRoute>
        } />
        <Route path="/o2c-agent/tracker" element={
          <PrivateRoute>
            <O2CAgent />
          </PrivateRoute>
        } />
        <Route path="/invoice-hub" element={
          <PrivateRoute>
            <OCRApp />
          </PrivateRoute>
        } />
        <Route path="/chat" element={
          <PrivateRoute>
            <Chat
              dashboardUrl={dashboardUrl}
              setDashboardUrl={handleSetDashboardUrl}
              activeNavItem={activeNavItem}
              setActiveNavItem={setActiveNavItem}
              showFAQ={showFAQ}
              setShowFAQ={setShowFAQ}
            />
          </PrivateRoute>
        } />
        <Route path='/register' element={<Register />} />
        <Route path="/otp-verification" element={<OtpVerification />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/reset-password' element={<ResetPassword />} />
      </Routes>
      {/* {!shouldHideWidget && (
        <ChatWidget
          isFAQActive={showFAQ}
        />
      )} */}
    </>
  );
}

function App() {
  const [dashboardUrl, setDashboardUrl] = useState('');
  const [activeNavItem, setActiveNavItem] = useState('Chat');
  const [showFAQ, setShowFAQ] = useState(false);

  const handleSetDashboardUrl = (url) => {
    setDashboardUrl(url);
  };

  return (
    <Router>
      <AppContent
        dashboardUrl={dashboardUrl}
        handleSetDashboardUrl={handleSetDashboardUrl}
        activeNavItem={activeNavItem}
        setActiveNavItem={setActiveNavItem}
        showFAQ={showFAQ}
        setShowFAQ={setShowFAQ}
      />
    </Router>
  );
}

export default App;